import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './MyDrive.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { usePage } from '../../hooks/usePage';

import { menuChanged, selectMenu } from '../../features/infoSlice';
import { selectDriveOptions } from '../../features/driveSlice';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';
import ListOption from '../../components/ListOption';
import List from '../../components/List';
import Details from '../../components/Details';
import { DRIVE, LIST } from '../../constants';

export default function MyDrive() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const options = useAppSelector(selectDriveOptions);
  const { isDetailsOpened, isEditMode } = options;
  const { pageChanged } = usePage();

  useEffect(() => {
    dispatch(menuChanged('mydrive'));
    menu === 'mydrive' && dispatch(pageChanged(0));
  }, []);

  if (menu !== 'mydrive') return null;

  return (
    <Container isSubPage={true}>
      <TopArea title={DRIVE} className="st_subpage" />
      <div className={cx('content')}>
        <div className={cx('section')}>
          <h2 className="blind">
            {DRIVE} {LIST}
          </h2>
          <ListOption />
          <div
            className={cx(
              'library_area',
              {
                'library--info-active': isDetailsOpened,
              },
              {
                'is--editing': isEditMode,
              }
            )}
          >
            <List />
            {isDetailsOpened && <Details />}
          </div>
        </div>
      </div>
    </Container>
  );
}
